import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';

// Hover mixin and `$enable-hover-media-query` are deprecated.
//
// Originally added during our alphas and maintained during betas, this mixin was
// designed to prevent `:hover` stickiness on iOS-an issue where hover styles
// would persist after initial touch.
//
// For backward compatibility, we've kept these mixins and updated them to
// always return their regular pseudo-classes instead of a shimmed media query.
//
// Issue: https://github.com/twbs/bootstrap/issues/25195

export class Hover extends Mixin {
  style({content}){
    return css`
      &:hover { ${content}; }
    `;
  }
}

export class HoverFocus extends Mixin {
  style({content}){
    return css`
      &:hover,
      &:focus {
        ${content};
      }
    `;
  }
}

export class PlainHoverFocus extends Mixin {
  style({content}){
    return css`
      &,
      &:hover,
      &:focus {
        ${content};
      }
    `;
  }
}

export class HoverFocusActive extends Mixin {
  style({content}){
    return css`
      &:hover,
      &:focus,
      &:active {
        ${content};
      }
    `;
  }
}
